export default __webpack_public_path__ + "static/media/step2.b72f83cf.png";